<template>
    <div class="header-new-chat header-tools-item" @click="$emit('click')">
        <button
            class="header-tools-item__button header-new-chat__button button button_size_small button_color_transp-black button_with_icon"
            :class="{ 'button_type_active': isOpen }"
            title="New Chat"
            @click="handleClick"
        >
            <div class="header_button_icon header-new-chat__icon">
                <svg aria-hidden="true" width="20" height="20">
                    <use href="#icon-cloud-chat"></use>
                </svg>
                <span v-if="fcmPermission === 'denied'" class="header-new-chat__alert" aria-label="Сповіщення заблоковано">!</span>
                <span v-else-if="totalUnread > 0" class="header-new-chat__counter">
                    {{ totalUnread > 99 ? '99+' : totalUnread }}
                </span>
            </div>
            <div class="header-tools-item__text is-desktop-hide">
                New Chat
            </div>
        </button>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@api'

export default {
    name: 'HeaderNewChatButton',
    computed: {
        ...mapGetters(['barNewChat']),
        ...mapGetters('newChat', ['fcmPermission', 'totalUnread']),
        isOpen() {
            return this.barNewChat && this.barNewChat.value
        }
    },
    mounted() {
        this.fetchCounter()
    },
    methods: {
        ...mapActions(['CHANGE_ACTIVE_BAR']),
        ...mapActions('newChat', ['setTotalUnread', 'setUnreadMyChats']),
        handleClick() {
            const value = !this.isOpen
            this.CHANGE_ACTIVE_BAR({ name: 'newChat', value })
        },
        fetchCounter() {
            api.newChat.getTotalCounter()
                .then(response => {
                    this.setTotalUnread((response.total_unread_my_chats_messages || 0) + (response.total_unread_new_chats_messages || 0))
                    this.setUnreadMyChats(response.total_unread_my_chats_messages || 0)
                })
                .catch(() => {})
        },
    }
}
</script>

<style lang="scss">
.header-new-chat {
    &__button {
        background-color: transparent;
        position: relative;
    }

    &__icon {
        position: relative;
    }

    &__alert {
        position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
        top: -4px;
        right: -2px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: #e94a4a;
        color: #fff;
        font-size: 9px;
        font-weight: 700;
        line-height: 14px;
        text-align: center;
        pointer-events: none;
    }

    &__counter {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 20px;
        height: 20px;
        position: absolute;
        top: -12px;
        right: 0;
        padding: 3px;
        font-size: 12px;
        background-color: #e94a4a;
        border-radius: 14px;
        border: 2px solid #fff;
        color: #fff;
        font-weight: 700;
        pointer-events: none;
    }
}
</style>
